@use '../../../utils.scss';
@use '../../../base-variables.scss';

.TextArea{
        outline: none;
        height: 83px;
        width: 100%;
        background-color: utils.color('lumen');
        border: unset;
        border-radius: 5px;
        font-size: 14px;
        padding: 8px 5px;

        &::placeholder{
                color: utils.color('standby-blue-gray');
        }

        &:focus {
                border: 1px solid utils.color('nebula');
                box-shadow: base-variables.$active-shadow;
                background-color: unset; 
        }
}

.Disabled {
        opacity: 0.6;
}
